<template>
  <section>
    <div class="z-card integration-page">
      <h4>{{ $t('integration.api.create_db') }}</h4>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/database</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>
        {{ $t('integration.api.example') }}
      </p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"database_ru"</span>,
      <span class="hljs-attr">"group_id"</span>: <span class="hljs-number">5</span>
  }
</code>
        </pre>

      <p>
        {{ $t('integration.api.answer_example') }}
      </p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">37</span>
  }
</code>
      </pre>
      <h4>{{ $t('integration.api.get_all_databases') }}</h4>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/database</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>
        {{ $t('integration.api.answer_example') }}
      </p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"databases"</span>: [
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-string">"database_56"</span>,
              <span class="hljs-attr">"group"</span>: <span class="hljs-literal">null</span>
          },
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">2</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-string">"database_88"</span>,
              <span class="hljs-attr">"group"</span>: <span class="hljs-number">2</span>
          }
      ]
  }
</code>
      </pre>
      <h4>{{ $t('integration.api.import') }}</h4>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/database/{id}/upload</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>
        {{ $t('integration.api.example') }}
      </p>
      <pre>
<code class="json hljs">
  {
    <span class="hljs-attr">"recipients"</span>:
    [
        {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79180000000"</span>,
            <span class="hljs-attr">"first_name"</span>: <span class="hljs-string">"Jeetendra sharma"</span>,
            <span class="hljs-attr">"country"</span>: <span class="hljs-string">"IN"</span>
        },
        {
            <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79190000123"</span>,
            <span class="hljs-attr">"first_name"</span>: <span class="hljs-string">"Rahul"</span>,
            <span class="hljs-attr">"country"</span>: <span class="hljs-string">"IN"</span>
        }
    ]
  }
</code>
      </pre>
      <p>
        {{ $t('integration.api.answer_example') }}
      </p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"data"</span>: [
          {
              <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2019-02-19 09:42:41"</span>,
              <span class="hljs-attr">"db_id"</span>: <span class="hljs-string">"60"</span>,
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79180000000"</span>,
              <span class="hljs-attr">"email"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"first_name"</span>: <span class="hljs-string">"Jeetendra sharma"</span>,
              <span class="hljs-attr">"last_name"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"city"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"country"</span>: <span class="hljs-string">"IN"</span>,
              <span class="hljs-attr">"age"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"sex"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"birthdate"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom1"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom2"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom3"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom4"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom5"</span>: <span class="hljs-literal">null</span>
          },
          {
              <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2019-02-19 09:42:41"</span>,
              <span class="hljs-attr">"db_id"</span>: <span class="hljs-string">"60"</span>,
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79190000123"</span>,
              <span class="hljs-attr">"email"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"first_name"</span>: <span class="hljs-string">"Rahul"</span>,
              <span class="hljs-attr">"last_name"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"city"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"country"</span>: <span class="hljs-string">"IN"</span>,
              <span class="hljs-attr">"age"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"sex"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"birthdate"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom1"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom2"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom3"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom4"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"custom5"</span>: <span class="hljs-literal">null</span>
          }
      ]
  }
</code>
      </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
